import Entity from "entity";

export default class Trator extends Entity {
    static get collectionUID() {
        return "ValueCustomForm/TPrvPu2YnY3ob1Ay4kui/Values";
    }

    static async onQuery(collection) {
        return collection.where("status", "==", "ATIVO").orderBy("numeroFrotaTrator");
    }

    async initialize() {
        this.data.status = "ATIVO"
    }

    static get labelField() {
        return "numeroFrotaTrator";
    }

    static get searchColumns() {
        return [
            { field: "sequencialIndex", headerName: "Código", flex: 0.8, filter: true },
            { field: "cliente.nome", headerName: "Cliente", flex: 1, filter: true },
            { field: "numeroFrotaTrator", headerName: "Nº Frota", flex: 1, filter: true },
            { field: "marcaTrator", headerName: "Marca", flex: 1, filter: true },
            { field: "modeloTrator", headerName: "Modelo", flex: 1, filter: true },
            { field: "nomeOperador", headerName: "Operador", flex: 1 },
        ];
    }
}
